const days = [1, 2, 3, 4, 5];

export const isOpen = (date) => {
	const dia = new Date(date).getDay();
	if (days.includes(dia)) {
		const open_mañana = new Date(new Date().setHours(10, 0, 0));
		const close_mañana = new Date(new Date().setHours(13, 0, 0));

		const open_tarde = new Date(new Date().setHours(16, 0, 0));
		const close_tarde = new Date(new Date().setHours(19, 0, 0));

		if (
			(new Date(date) > open_mañana && new Date(date) < close_mañana) ||
			(new Date(date) > open_tarde && new Date(date) < close_tarde)
		) {
			return true;
		} else {
			return false;
		}
	} else {
		return false;
	}
};
